import { __assign, __extends, __rest, __spreadArray } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { compose } from 'redux';
import get from 'lodash/get';
import ElementQueries from '../../../ElementQueries';
import { getDeviationEntityId } from '../../../redux/normalizr/schemas/deviation';
import { DndSortable, DndSortableElement, } from '../../../Dnd/DndSortable';
import { DraggableType } from '../../../types/dnd';
import withCurrentGallection from '../../_hocs/withCurrentGallection';
import withFileUpload from '../../_hocs/withFileUpload';
import { MediaSourceType } from '../../types';
import { areGallectionContentsManageable } from '../../helpers';
import UploadThumb from '../../_partials/UploadThumb';
import withCurrentMediaSource from '../../_hocs/withCurrentMediaSource';
import s from './DeviationGrid.scss';
var enhance = compose(withFileUpload, withCurrentMediaSource, withCurrentGallection);
var DeviationGrid = /** @class */ (function (_super) {
    __extends(DeviationGrid, _super);
    function DeviationGrid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderDndDeviation = function (_a) {
            var draggedElementId = _a.draggedElementId, dndProps = __rest(_a, ["draggedElementId"]);
            return function (deviation, index) {
                var _a = _this.props, currentMediaSource = _a.currentMediaSource, currentGallection = _a.currentGallection, deviationRenderer = _a.deviationRenderer, deviations = _a.deviations, moveDeviationToPosition = _a.moveDeviationToPosition;
                var isDragging = draggedElementId === deviation.deviationId;
                var areDeviationsSortable = false;
                if (currentMediaSource === MediaSourceType.CUSTOM_SET) {
                    areDeviationsSortable = true;
                }
                else if (currentMediaSource &&
                    [MediaSourceType.TIER_DEVIATIONS, MediaSourceType.TIER_POSTS].includes(currentMediaSource)) {
                    areDeviationsSortable = false;
                }
                else {
                    areDeviationsSortable =
                        !!moveDeviationToPosition &&
                            !!currentGallection &&
                            areGallectionContentsManageable(currentGallection);
                }
                var entityId = getDeviationEntityId(deviation);
                return (React.createElement(DndSortableElement, __assign({ dndType: DraggableType.MEDIA_MANAGER_DEVIATION, id: entityId, key: entityId, position: index, isSortable: areDeviationsSortable }, dndProps), function (options) { return (React.createElement("div", { className: classnames(s['grid-item'], isDragging && s['dragging']), ref: options.ref }, deviationRenderer(deviation, index, deviations))); }));
            };
        };
        _this.renderFileUpload = function (fileUpload) {
            var currentGallection = _this.props.currentGallection;
            var file = fileUpload.file, fileId = fileUpload.fileId, folderId = fileUpload.folderId, progress = fileUpload.progress, error = fileUpload.error;
            if (!file ||
                !currentGallection ||
                currentGallection.folderId !== folderId ||
                currentGallection.type !== MediaSourceType.STASH) {
                return null;
            }
            return (React.createElement(UploadThumb, { key: "upload-".concat(fileId), className: s['grid-item'], file: file, progress: progress, error: error }));
        };
        _this.findDeviationByEntityId = function (entityId) {
            return _this.props.deviations.find(function (deviation) { return getDeviationEntityId(deviation) === entityId; });
        };
        _this.onDndDrop = function (entityId, position) {
            var deviation = _this.findDeviationByEntityId(entityId);
            if (deviation) {
                _this.props.moveDeviationToPosition({
                    deviation: deviation,
                    position: position,
                    moveType: 'papiOnly',
                });
            }
        };
        _this.onDndDragOver = function (entityId, position) {
            var deviation = _this.findDeviationByEntityId(entityId);
            if (deviation) {
                _this.props.moveDeviationToPosition({
                    deviation: deviation,
                    position: position,
                    moveType: 'streamOnly',
                });
            }
        };
        return _this;
    }
    DeviationGrid.prototype.shouldComponentUpdate = function (nextProps) {
        var _this = this;
        // We need to update the component if either the deviation or fileUploads
        // array has changed.
        if (nextProps.deviations.length !== this.props.deviations.length ||
            nextProps.fileUploads.length !== this.props.fileUploads.length) {
            return true;
        }
        // If the deviations array has different deviationIds
        var deviationsDidUpdate = !!nextProps.deviations.find(function (deviation, index) {
            return deviation.deviationId !==
                get(_this, "props.deviations[".concat(index, "].deviationId"));
        });
        // ...or if the files that are currently uploading have different fileIds
        // or different progress, we need to  re-render the file upload thumb
        var fileUploadsDidUpdate = !!nextProps.fileUploads.find(function (fileUpload, index) {
            return fileUpload.fileId !== get(_this, "props.fileUploads[".concat(index, "].fileId")) ||
                fileUpload.progress !==
                    get(_this, "props.fileUploads[".concat(index, "].progress"));
        });
        return deviationsDidUpdate || fileUploadsDidUpdate;
    };
    DeviationGrid.prototype.render = function () {
        var _this = this;
        return (React.createElement(DndSortable, { onDrop: this.onDndDrop, onDragOver: this.onDndDragOver }, function (props) { return (React.createElement(ElementQueries, { widthBreakpoints: [1100, 800, 700, 450], className: s['grid'] }, __spreadArray(__spreadArray([], _this.props.fileUploads
            .sort(function (a, b) { return a.fileId - b.fileId; })
            .map(_this.renderFileUpload), true), _this.props.deviations.map(_this.renderDndDeviation(props)), true))); }));
    };
    return DeviationGrid;
}(React.Component));
export { DeviationGrid };
export default enhance(DeviationGrid);
//# sourceMappingURL=DeviationGrid.js.map